import { appInsights } from "us.helper";
import { CaseType } from "us.helper/types/enums";
import { ICaseSubCasesFrom } from "../Interfaces";

/**
 * @function
 * @description - Check for the desition to dissable the Create-case button
 * @param {ICaseSubCasesFrom} values - form values
 * @return {*}  {boolean} - boolean decision if the create case button is dissabled
 */
export const isCreateCaseButtonDisabled = (
  values: ICaseSubCasesFrom,
): boolean => {
  try {
    if (!values.selectedCases || values.selectedCases.length === 0) {
      return true;
    }
    const hasParentCaseSelected = values.selectedCases?.some(
      (caseItem) => caseItem.parentId > 0,
    );
    const hasCreateDisabledSubcaseSelected = values.selectedCases?.some(
      (caseItem) =>
        caseItem.caseType == CaseType.S && !caseItem.isCreateEnabled,
    );
    return hasParentCaseSelected || hasCreateDisabledSubcaseSelected;
  } catch (error) {
    appInsights.trackException(
      `Cases and Subcases Home isCreateCaseButtonDisabled error - ${error}`,
    );
    return true;
  }
};
